<template>
  <div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">FechaReg</th>
          <th scope="col">TarifarioDescripcion</th>
          <th scope="col">AseguradorNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tarifaaseg in datosPaginados" :key="tarifaaseg.idTarifaAseg">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tarifaaseg.idTarifaAseg)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tarifaaseg.idTarifaAseg)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(tarifaaseg.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{tarifaaseg.tarifarioDescripcion}}</td>
          <td>{{tarifaaseg.aseguradorNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTarifaAseg(tarifaaseg.idTarifaAseg)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifaAseg" class="form-label">IdTarifaAseg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifaAseg" name="idTarifaAseg" v-model="datoTarifaAseg.idTarifaAseg" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Tarifario -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTarifario" class="form-label"> Tarifario</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTarifario" name="idTarifario" v-model="datoTarifaAseg.idTarifario">
                      <option v-for="tarifario in tarifarios" :value="tarifario.idTarifario" :key="tarifario.idTarifario">
                        {{ tarifario.descripcion }} - {{ tarifario.asegurador_nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Tarifario -->
<!-- Botón Lista de Valores  Asegurador -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idAsegurador" class="form-label"> Asegurador</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAsegurador" name="idAsegurador" v-model="datoTarifaAseg.idAsegurador">
                      <option v-for="asegurador in aseguradors" :value="asegurador.idAsegurador" :key="asegurador.idAsegurador">
                        {{ asegurador.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Asegurador -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoTarifaAseg.fechaReg" disabled>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifaAseg" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifaAseg" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '../../modules/validacionesForms.js'
import dateFormat from '../../modules/dateFormat.js';
import { format } from 'date-fns';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
  },
  data () {
    return {
      tarifaasegs : [],
      datoTarifaAseg : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tarifarios: [],
      aseguradors: [],
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  computed: {
    formattedFechaReg() {
      const originalDate = new Date(this.datoAuto.fechaReg);
      return format(originalDate, 'dd/MM/yyyy');
    },
  },

  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchTarifarios()
    this.fetchAseguradors()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.tarifaasegs.length / this.elementosPorPagina)
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtarifaasegs').then(response=>{ 
      this.tarifaasegs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tarifaasegs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idTarifario'
        ,'idAsegurador'
      ];
      const requiredFieldsText = [
        'idTarifario'
        ,'idAsegurador'
      ];
      return validarForm(this.datoTarifaAseg, requiredFields, requiredFieldsText);
    },
    async guardarTarifaAseg(){
      if(this.validarForm() === 1){
        try {		  
          await api.post('/tarifaasegs', this.datoTarifaAseg)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "TarifaAseg creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifaAseg(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifaasegs', this.datoTarifaAseg)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "TarifaAseg creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTarifaAseg={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idTarifaAseg){
      this.modalWindow = true
      if(idTarifaAseg != null){    
           api.get('/vwtarifaasegs/'+idTarifaAseg).then(resp=>{
          this.datoTarifaAseg = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idTarifaAseg){
      if(idTarifaAseg != null){
        this.$router.push('/tarifaasegmd/'+idTarifaAseg)
      }
    },
    async deleteTarifaAseg (idTarifaAseg) {
      try{
        await api.delete('/tarifaasegs/'+idTarifaAseg)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
async fetchTarifarios() {
  try {
    const response = await api.get("/vwtarifarios");
    this.tarifarios = response.data;
  } catch (error) {
    console.error("Error al obtener los tarifarios:", error);
  }
},

async fetchAseguradors() {
  try {
    const response = await api.get("/vwaseguradors");
    this.aseguradors = response.data;
  } catch (error) {
    console.error("Error al obtener los aseguradors:", error);
  }
},
  },
}
</script>